import { Me } from '#/api/types';
import { getAuthStore } from '#/screens/auth/auth.utils';

const defaultConfig: Record<string, { default: boolean; admin: boolean }> = {
  billingEnabled: { default: true, admin: false },
  supportEnabled: { default: false, admin: true },
};

const getConfigValue = (key: string, user?: Me): boolean => {
  const config = defaultConfig[key];
  const auth = getAuthStore();

  if (!config) {
    return false;
  }

  if (config.admin && !auth.webAuth?.admin) {
    return false;
  }

  if (config.admin && auth.webAuth?.admin) {
    return true;
  }

  return config.default;
};

export { getConfigValue };
